<template>
  <v-dialog persistent v-model="dialog" max-width="800">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card :loading="loading">
        <v-card-title class="headline">{{ (isNew) ? 'Nuova registrazione' : 'Modifica registrazione' }}</v-card-title>
        <v-card-subtitle>{{ (isNew) ? 'Registra una nuova attività' : 'Modifica una registrazione esistente' }}</v-card-subtitle>
        <v-card-text class="py-0">
          <v-row>
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Data</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-menu ref="refRegPickerMenu" v-model="regPicker" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field :value="formattedDatReport" v-on="on" placeholder="Data dell'attività" :rules="requiredRules" single-line filled dense required clearable></v-text-field>
                </template>
                <v-date-picker v-model="event.datReport" locale="it-it" :max="current" no-title scrollable @change="regPicker = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row style="margin-top: -25px;">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Orario</v-subheader>
            </v-col>
            <v-col xl="5" lg="5" md="5" sm="5" xs="6">
              <v-combobox v-model="event.datStart" :items="hoursFrom" placeholder="Inizio" :rules="rangeStartRules" single-line filled dense required clearable></v-combobox>
            </v-col>
            <v-col xl="5" lg="5" md="5" sm="5" xs="6">
              <v-combobox v-model="event.datEnd" :items="hoursTo" placeholder="Fine" :rules="rangeEndRules" single-line filled dense required clearable></v-combobox>
            </v-col>
          </v-row>
          <!-- <v-row style="margin-top: -25px;">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Area</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-select 
                v-model="event.areaId" 
                :items="areas" item-value="id" item-text="description" @change="selectActivities()" 
                placeholder="Area di pertinenza" no-data-text="Nessuna area presente"
                :rules="requiredRules" single-line filled dense required clearable>
              </v-select>
            </v-col>
          </v-row> -->
          <v-row style="margin-top: -25px;">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Attività</v-subheader>
            </v-col>
            <v-col xl="4" lg="4" md="4" sm="4" xs="12">
              <v-select 
                v-model="event.areaId" 
                :items="areas" item-value="id" item-text="description" @change="selectActivities()" 
                placeholder="Area di pertinenza" no-data-text="Nessuna area presente"
                :rules="requiredRules" single-line filled dense required clearable>
              </v-select>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" xs="12">
              <v-select 
                v-model="event.activityId" 
                :items="activities" item-value="id" item-text="description" 
                placeholder="Attività svolta" no-data-text="Nessuna attività presente"
                :rules="requiredRules" single-line filled dense required clearable></v-select>
            </v-col>
            <!-- <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-select 
                v-model="event.activityId" 
                :items="activities" item-value="id" item-text="description" 
                placeholder="Attività svolta" no-data-text="Nessuna attività presente"
                :rules="requiredRules" single-line filled dense required clearable></v-select>
            </v-col> -->
          </v-row>
          <v-row style="margin-top: -25px;">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Note</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-textarea v-model="event.notes" placeholder="Note sull'attività" :counter="250" :row-height="14" auto-grow single-line filled dense required clearable></v-textarea>
            </v-col>
          </v-row>
          <v-row dense style="margin-top: -25px;">
            <v-col cols="12">
              <v-checkbox v-model="event.flagSmartWorking" label="Attività svolta in modalità Smart Working"></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="error.hasErrors">
            <v-col class="col-12" v-for="(e, i) in error.errors" :key="i">
              <v-alert dense outlined type="error"><strong>ATTENZIONE!</strong> {{ e }}</v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small dark color="red" @click="clear()">Annulla</v-btn>
          <v-btn small dark color="green" :loading="loading" @click="save()">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import apiRepository from '../../api/api-repository';

moment.locale('it');

const  selectableHours = [ '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
  '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
  '21:00', '21:30', '22:00', '22:30', '23:00', '23:30' ];

const validateTime = (v)=> {
  const regex = /^(\d{2}):(\d{2})$/, matches = regex.exec(v);
  if(matches == null) return false;
  const hours = parseInt(v.split(':')[0], 10), minutes = parseInt(v.split(':')[1], 10);
  if(!(hours >= 0 && hours <= 23) || !(minutes >= 0 && minutes <= 59)) return false;
  return true;
};

const validateRange = (start, end)=> {
  if(start == undefined || end == undefined) return true;
  const today = moment().format('YYYY-MM-DD'), 
    rangeStart = moment(`${today}T${start}`), rangeEnd = moment(`${today}T${end}`);
  return (rangeStart.isBefore(rangeEnd));
};

export default {
  name: 'EventForm',
  props: [ 'isNew', 'event' ],

  data: ()=> ({
    // flag di gestione del componente.
    lazy: true, // tipo di validazione del form.
    valid: true, // stato di validazione del form.
    dialog: false, // apre/chiude la dialog contenente il form.
    loading: false, // abilita/disabilita il caricamento durante l'operazione.
    regPicker: false, // apre/chiude il date picker della data di registrazione.
    // stato degli errori.
    error: { hasErrors: false, errors: new Array() }, // stato degli errori.
    // liste di selezione.
    areas: new Array(), // lista delle aree di pertinenza.
    activities: new Array(), // lista delle attività disponibili.
    // regole per i campi obbligatori.
    requiredRules: [ (v)=> !!v || 'Campo obbligatorio' ],
  }),

  computed: {
    rangeStartRules(){
      const rules = [ ];
      const requiredRule = (v)=> !!v || 'Campo obbligatorio';
      const validTimeRule = (v)=> (v != undefined) ? (validateTime(v)) || 'Formato non valido.' : '';
      const validRangeRule = (v)=> (v != undefined) ? (validateRange(v, this.event.datEnd)) || 'Intervallo non valido' : '';
      rules.push(requiredRule, validTimeRule, validRangeRule);
      return rules;
    },
    rangeEndRules(){
      const rules = [ ];
      const requiredRule = (v)=> !!v || 'Campo obbligatorio';
      const validTimeRule = (v)=> (v != undefined) ? (validateTime(v)) || 'Formato non valido.' : '';
      const validRangeRule = (v)=> (v != undefined) ? (validateRange(this.event.datStart, v)) || 'Intervallo non valido' : '';
      rules.push(requiredRule, validTimeRule, validRangeRule);
      return rules;
    },
    formattedDatReport(){
      return (this.event.datReport) ? moment(this.event.datReport).format('DD/MM/YYYY') : '';
    },
    hoursFrom(){
      let hours = [ ...selectableHours ];
      const hm = (this.event.datEnd) ? this.event.datEnd.split(':') : [ '23', '30' ], 
        hour = parseInt(hm[0], 10), minute = parseInt(hm[1], 10);

      let nextHours, nextMinutes;

      if(minute === 0){
        nextHours = hour - 1; nextMinutes = 30;
      }
      else if(minute > 0 && minute <= 30){
        nextHours = hour; nextMinutes = 0;
      }
      else{
        nextHours = hour; nextMinutes = 30;
      }

      const next = moment({ hour: nextHours, minute: nextMinutes }).format('HH:mm');
      const i = hours.indexOf(next);
      return hours.splice(0, i + 1);
    },
    hoursTo(){
      let hours = [ ...selectableHours ];
      const hm = (this.event.datStart) ? this.event.datStart.split(':') : [ '07', '00' ], 
        hour = parseInt(hm[0], 10), minute = parseInt(hm[1], 10);
  
      let nextHours, nextMinutes;
      
      if(minute >= 30){
        nextHours = hour + 1; nextMinutes = 0;
      }
      else{
        nextHours = hour; nextMinutes = 30;
      }

      const next = moment({ hour: nextHours, minute: nextMinutes }).format('HH:mm');
      const i = hours.indexOf(next);
      return hours.splice(i, (hours.length - 1));
    }
  },

  methods: {
    open(){
      this.init();
      if(this.$refs.form) this.$refs.form.resetValidation(); // resetto la validazione del form.
      this.valid = true; // setto il flag di validità del form.
      this.dialog = true; // apro la dialog contenente il form.
    },

    clear(){
      this.dialog = false; // chiudo la dialog contenente il form.
      this.error = { hasErrors: false, errors: new Array() }; // resetto il box degli errori.
      this.$refs.form.resetValidation(); // resetto la validazione del form.
    },

    async selectActivities(){
      this.event.activityId = null; // resetto il valore dell'attività precedentemente selezionata.
      const res = await apiRepository.activities().findByAreaId(this.event.areaId); // attendo la risposta dalla api.
      this.activities = res.data; // assegno alla lista del componente le attività trovate.
    },

    async save(){
      // se il form non è valido esco dal salvataggio.
      if(!this.$refs.form.validate()) return;
      // form valido, proseguo con il salvataggio.
      this.loading = true; // setto il form il caricamento.
      // preparo la richiesta per la creazione/modifica della registrazione.
      const req = { 
        id: (this.isNew) ? null : this.event.id, 
        datReport: this.event.datReport,
        datStart: `${this.event.datReport}T${this.event.datStart}`, 
        datEnd: `${this.event.datReport}T${this.event.datEnd}`,
        areaId: this.event.areaId, 
        activityId: this.event.activityId, 
        notes: (this.event.notes && this.event.notes.length > 0) ? this.event.notes : null,
        flagSmartWorking: this.event.flagSmartWorking 
      };

      try{
        // chiamo la api di creazione/modifica di una registrazione.
        const res = (this.isNew) ? await apiRepository.events().create(req) : await apiRepository.events().update(req);
        // aggiorno lo stato della dialog.
        this.loading = false; // disabilito il caricamento del form.
        this.clear(); // pulisco lo stato del form.
        // emetto l'evento di salvataggio avvenuto.
        this.$emit('saved', res); // restituisco il risultato agli ascoltatori.
      }
      catch(e){
        console.error('exception:', e); // loggo l'errore riscontrato.
        this.loading = false; // disabilito il caricamento del form.
        this.error.hasErrors = true; // abilito il box degli errori.
        this.error.errors = e.errors; // aggiorno la lista degli errori.
      }
    },

    async init(){
      // recupero le aree di pertinenza dalle api.
      const areaRes = await apiRepository.area().findByUser(); // attendo la risposta dalle api.
      this.areas = areaRes.data; // assegno alla lista del componente le aree trovate.

      if(this.event.areaId){
        const activityRes = await apiRepository.activities().findByAreaId(this.event.areaId);
        this.activities = activityRes.data;
      }
    }
  }
}
</script>